export const convertLocaleDate = (timestamp, showWeekDay) => {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    ...(showWeekDay && { weekday: 'long' })
  }
  const dateString = date.toLocaleDateString('pt-BR', options)
  if (showWeekDay) {
    return dateString.replace(/^\w/, (c) => c.toUpperCase())
  }
  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1')
}

export const convertLocaleDateWithoutTime = (timestamp, showWeekDay) => {
  const date = new Date(timestamp)
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...(showWeekDay && { weekday: 'long' })
  }
  const dateString = date.toLocaleDateString('pt-BR', options)
  if (showWeekDay) {
    return dateString.replace(/^\w/, (c) => c.toUpperCase())
  }
  return dateString.replace(/(\d{4})(\s+\d{2}:\d{2})/, '$1')
}
